<script>
  export let show = false
  export let header
  export let menuItems

  let menuElement

  const closeDialogMenu = function () {
    if (show) {
      show = false
    }
  }

  const hideOnClickOutside = function (event) {
    if (menuElement && !menuElement.contains(event.target)) {
      closeDialogMenu()
    }
  }

  const runFunc = function (func) {
    Promise.resolve()
      .then(() => func())
      .then(() => closeDialogMenu())
  }
</script>

{#if show}
  <div class="dialogLayer" on:click={hideOnClickOutside}>
    <div class="dialogMenu" bind:this={menuElement}>
      {#if header !== undefined}
        <div class="header">{header}</div>
      {/if}
      <ul>
        {#each menuItems as item}
          <li>
            {#if item.type === 'button'}
              <button on:click="{() => runFunc(item.func)}">
                {item.text}
              </button>
            {:else if item.type === 'link'}
              <a class="greyLink" href="{item.href}" on:click={closeDialogMenu}>
                {item.text}
              </a>
            {/if}
          </li>
        {/each}
      </ul>
    </div>
  </div>
{/if}

<style>
  div.dialogLayer {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    padding: 10px;

    background-color: #FFF8;
  }

  div.dialogMenu {
    display: flex;
    flex-direction: column;

    min-width: 150px;
    max-width: 100%;

    background-color: white;
    border-radius: 10px;
    box-shadow: 0 0 10px #0004;
  }
  div.dialogMenu .header {
    padding: 15px 20px;
    border-bottom: 1px solid var(--border-color);

    font-weight: 500;
  }

  ul {
    display: flex;
    flex-direction: column;

    list-style: none;

    padding: 0;
    margin: 0;
  }
  ul li {
    padding: 0;
  }
  ul li > * {
    display: block;

    width: 100%;
    padding: 15px 20px;
  }
  ul li:first-child > * {
    padding-top: 20px;
  }
  ul li:last-child > * {
    padding-bottom: 20px;
  }
  ul li > button {
    border: none;
    border-radius: 0;

    background-color: unset;
    text-align: left;
  }
  ul li > button:hover,
  ul li > button:active {
    background-color: unset;
  }

  @media only screen and (min-width: 450px) and (min-height: 550px) {
    div.dialogLayer {
      padding: 30px;
    }
  }
</style>
